<template>
    <a
        class="btn btn-default btn-lg btn-raised btn-padding"
        :class="{ 'btn-press': value !== null, 'font-color-invert': value !== null }"
        @click="emitNewOrder"
    >
        {{ label }}
        <kgr-icon
            v-if="value !== null"
            :icon-class="iconClass"
            :small="true"
            class="kgr-actionButton__icon"
            style="display: inline-block; width: 16px; height: 16px; line-height: 0;"
        />
    </a>
</template>

<script>
import KgrIcon from '../common/icon/Icon.vue';

export default {
    components: {
        'kgr-icon': KgrIcon,
    },
    props: {
        value: {
            type: String,
            required: false,
            default: null,
        },
        label: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
        }
    },
    computed: {
        iconClass() {
            if(this.value === null) {
                return null;
            }

            return this.value === 'asc' ? 'arrow-down' : 'arrow-up';
        },
    },
    mounted() {
    },
    methods: {
        emitNewOrder() {
            let newOrder;
            if(this.value === null) {
                newOrder = 'asc';
            } else if(this.value === 'asc') {
                newOrder = 'desc';
            } else {
                newOrder = null;
            }
            this.$emit('input', newOrder);
            this.$nextTick(() => {
                this.$emit('post-input', newOrder);
            });
        },
    }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped="scoped">
.tabletView {
    .font-color-invert {
        color:white;
    }

    .btn-padding {
        padding: 0 10px !important;
    }

}
</style>
